import { A11yModule } from "@angular/cdk/a11y";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { SharedModule } from "lib-trend-core";
import { ContacttModule } from "../attendance/attendance-panel/attendance-panel-components/contact/contact.module";
import { SoftphoneModule } from "../softphone/softphone.module";
import { CardDetailsComponent } from './card-details/card-details.component';
import { CardFormComponent } from './card-form/card-form.component';
import { CardItemComponent } from './card-item/card-item.component';
import { CardRadarModule } from './card-radar/card-radar.module';
import { ActivityDialogsModule } from '../task/activity-dialogs/activity-dialogs.module';
import { CategoryQuickFormComponent } from './category-quick-form/category-quick-form.component';
import { CustomerQuickFormComponent } from './customer-quick-form/customer-quick-form.component';
import { CustomerFormModalComponent } from './customer/customer-form-modal/customer-form-modal.component';
import { CustomerComponent } from './customer/customer.component';
import { DeleteDealDialogComponent } from './delete-deal-dialog/delete-deal-dialog.component';
import { FilterPanelComponent } from './filter-panel/filter-panel.component';
import { FunnelFormComponent } from './funnel-form/funnel-form.component';
import { FunnelOverviewComponent } from './funnel-overview/funnel-overview.component';
import { KanbanRoutingModule } from "./kanban-routing.module";
import { LeadQualityConfigComponent } from './lead-quality-config/lead-quality-config.component';
import { CrmListsConfigComponent } from './crm-lists-config/crm-lists-config.component';
import { PresentationDateDialogComponent } from './presentation-date-dialog/presentation-date-dialog.component';
import { KanbanComponent } from "./kanban.component";
import { LossReasonFormModalComponent } from './loss-reason/loss-reason-form-modal/loss-reason-form-modal.component';
import { LossReasonComponent } from './loss-reason/loss-reason.component';
import { NextActionDialogComponent } from './next-action-dialog/next-action-dialog.component';
import { SelectLossReasonComponent } from './loss-reason/select-loss-reason/select-loss-reason.component';
import { ProductQuickFormComponent } from './product-quick-form/product-quick-form.component';
import { ScoreExplanationComponent } from './score-explanation/score-explanation.component';
import { ProductFormModalComponent } from './product/product-form-modal/product-form-modal.component';
import { ProductComponent } from './product/product.component';
import { StageColumnComponent } from './stage-column/stage-column.component';
import { StageFormComponent } from './stage-form/stage-form.component';
import { CRMEffects } from "./state/effects";
import { crmReducers } from "./state/reducers";
import { TransferCardComponent } from './transfer-card/transfer-card.component';
import { CardListComponent } from './card-list/card-list.component';
import { CardUploadComponent } from './card-upload/card-upload.component';

@NgModule({
  imports: [
    KanbanRoutingModule,
    SharedModule,
    DragDropModule,
    A11yModule,
    ContacttModule,
    SoftphoneModule,
    CardRadarModule,
    // The conclusion and postpone dialogs, and the shared next-activity form (E4 RF-17).
    ActivityDialogsModule,

    // ngrx
    EffectsModule.forFeature([CRMEffects]),
    StoreModule.forFeature('crmState', crmReducers)
  ],
  declarations: [
    KanbanComponent,
    CardFormComponent,
    StageFormComponent,
    FunnelFormComponent,
    ProductQuickFormComponent,
    CustomerQuickFormComponent,
    ProductComponent,
    CustomerComponent,
    LossReasonComponent,
    ProductFormModalComponent,
    CustomerFormModalComponent,
    LossReasonFormModalComponent,
    CardDetailsComponent,
    SelectLossReasonComponent,
    CategoryQuickFormComponent,
    FilterPanelComponent,
    StageColumnComponent,
    CrmListsConfigComponent,
    PresentationDateDialogComponent,
    CardItemComponent,
    FunnelOverviewComponent,
    NextActionDialogComponent,
    DeleteDealDialogComponent,
    ScoreExplanationComponent,
    TransferCardComponent,
    CardListComponent,
    CardUploadComponent,
    LeadQualityConfigComponent,
  ],
  exports: [KanbanComponent],
})
export class KanbanModule { }
